import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Form, FormText } from 'react-bootstrap';

import VerbNumericInput from '../inputs/VerbNumericInput';
import WithTranslation from '../../../hocs/WithTranslation';

class BasicNumericInput extends Component {
    static propTypes = {
        className: PropTypes.string,
        input: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        minValue: PropTypes.number,
        maxValue: PropTypes.number,
        step: PropTypes.number,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        formatFunction: PropTypes.func,
        parseFunction: PropTypes.func,
        description: PropTypes.string,
        inputClassName: PropTypes.string,
        precision: PropTypes.number,
        styleProps: PropTypes.object
    };

    getGroupClassName = () => {
        const { required, className } = this.props;
        return cns(className, {
            required
        });
    };

    getFeedbackMessage = () => {
        const { touched, error, warning } = this.props.meta;
        let message = '';
        if (touched) {
            if (error) {
                message = error;
            } else if (warning) {
                message = warning;
            }
        }
        return message;
    };

    getValidationState = () => {
        const { touched, error, warning } = this.props.meta;
        if (touched && error) {
            return 'error';
        }
        if (touched && warning) {
            return 'warning';
        }
        return null;
    };

    render() {
        const {
            label,
            description,
            input,
            meta,
            required = false,
            disabled = false,
            minValue,
            maxValue,
            step,
            precision,
            placeholder,
            formatFunction,
            parseFunction,
            styleProps = {},
            inputClassName
        } = this.props;
        const { horizontal = false, inputStyle = {} } = styleProps;
        let labelSection = null;
        if (label || description) {
            labelSection = (
                <div className={horizontal ? 'col-12 col-sm-6 no-padding' : null}>
                    <div className={horizontal ? 'col-12 col-sm-10 no-padding' : null}>
                        <label htmlFor={input.name} className={horizontal ? 'form-label' : null}>
                            {label}
                            {required && <span className={'required-tag'}>*</span>}
                        </label>
                        <p className={horizontal ? 'form-description' : null}> {description} </p>
                    </div>
                </div>
            );
        }
        return (
            <Form.Group className={this.getGroupClassName()} validated={this.getValidationState()}>
                {labelSection}
                <VerbNumericInput
                    className={cns('basic-numeric-input', inputClassName, inputStyle)}
                    input={input}
                    meta={meta}
                    minValue={minValue}
                    maxValue={maxValue}
                    step={step}
                    precision={precision}
                    placeholder={placeholder}
                    formatFunction={formatFunction}
                    parseFunction={parseFunction}
                    required={required}
                    disabled={disabled}
                />
                <FormText>{this.getFeedbackMessage()}</FormText>
            </Form.Group>
        );
    }
}

export default WithTranslation(BasicNumericInput);
